import { Route, Routes, useNavigate } from 'react-router-dom'
import React, { lazy } from 'react'
import { useAppSelector } from '../hooks'
import { permissionsUser } from '../store/selectors'
import { ROUTES } from './const'

const SubcontractorPage = lazy(() => import('pages/SubcontractorsPage'))
const SubcontractorProfile = lazy(() => import('pages/SubcontractorProfile'))

const SubcontractorsRoutes = () => {
    const navigate = useNavigate()
    const { isSuperAdmin } = useAppSelector(permissionsUser)

    if (isSuperAdmin) {
        navigate(ROUTES.DASHBOARD)
    }
    return (
        <Routes>
            <Route index element={<SubcontractorPage />} />
            <Route path="/:id" element={<SubcontractorProfile />} />
        </Routes>
    )
}

export default SubcontractorsRoutes
